var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('request-products', {
    attrs: {
      "multiple-products": false,
      "loader": _vm.isShowLoader,
      "on-next": _vm.fetchRequestFields,
      "tariff": _vm.tariff,
      "balance": _vm.requestBalance,
      "individualProducts": _vm.individualProducts,
      "legalProducts": _vm.legalProducts
    },
    on: {
      "tariff-closed": _vm.fetchProducts
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d951d31","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProducts/RequestProductsContainer.vue
// module id = 1079
// module chunks = 0